const icon = {
    users :  require('../images/icon/users.png'),
    assets :  require('../images/icon/assets.png'),
    trading :  require('../images/icon/trading.png'),
    user :  require('../images/icon/user.png'),
    box :  require('../images/icon/box.png'),
    payment :  require('../images/icon/payment.png'),
    leftquote :  require('../images/icon/left-quote.png'),
    leftquote2 :  require('../images/testimonial/left-quote.png'),
}

export default icon;